var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-len */
import React from 'react';
import { Translate } from "../../../../I18N";

export const landingPageTip = /*#__PURE__*/
_jsx(Translate, { translationKey: "Landing page description" }, void 0,
`The landing page is the first page that visitors see when they come to your collection. The default landing page is your collection's library. You can set a different landing page by adding its relative URL here.
      For example:
      
      A page: */page/dicxg0oagy3xgr7ixef80k9*
      A filtered view in Uwazi: */library/?searchTerm=test*
      An entity: */entity/9htbkgpkyy7j5rk9*
      A document: */document/4y9i99fadjp833di*
      
      Important: You must use relative URLs. These start with a forward slash and do not include the domain name. For example: In the address *https://yoursite.com/landingpage*, the relative URL is /landingpage
      `
);


export const customFavIcon = /*#__PURE__*/
_jsx(Translate, { translationKey: "Favicon description" }, void 0,
`A favicon is a small icon that represents your collection in browser tabs and bookmarks. The
      default favicon is the Uwazi logo. To use your own:

        1. Upload your icon in Custom Uploads.
        2. Copy its URL.
        3. Choose "Custom Icon" and paste the URL in the indicated field.
        4. Reload the page to see your favicon in action.
      `
);


export const publicSharing = /*#__PURE__*/
_jsx(Translate, {}, void 0, "Check to make this instance public (non-logged in users can see public documents and entities)"

);


export const cookiePolicy = /*#__PURE__*/
_jsx(Translate, {}, void 0, "This option will show a notification about the use of cookies in your instance."

);


export const receivingEmail = /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, { translationKey: "Receiving email description" }, void 0, "If you have a contact form, this is the email address that will receive the form's submissions."


), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "Click"), "\xA0", /*#__PURE__*/
_jsx("a", {
  href: "https://uwazi.readthedocs.io/en/latest/admin-docs/managing-settings.html#how-to-configure-a-contact-form-or-submission-form",
  target: "_blank",
  rel: "noreferrer",
  className: "underline text-primary-700 hover:text-primary-900 visited:text-primary-700" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "here")
), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "to learn how to add and configure a contact form on a webpage.")
);

export const emails = [/*#__PURE__*/
_jsx(Translate, { translationKey: "Contact email description" }, void 0, "Here you can set up the contact email and the email that appears when Uwazi sends a notification to a user"


), /*#__PURE__*/

_jsx(Translate, { translationKey: "Sending email description" }, void 0,
`This is the email address that will appear as the sender when an email is sent from your Uwazi
    collection to registered users. The default address is *no-reply@uwazi.io*. You can set a custom
    one by including your desired email address here.`
)];


export const characterSupport = /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, { translationKey: "Character support description" }, void 0, "This option enhances support for non-Latin languages as the default languages of your collection. Selecting this option will update all template properties automatically. The process could take several minutes. Selecting this option will likely change the URLs of library filters. As a consequence, if you have menus or links using such URLs, they will probably stop working. You will need to update them manually. After selecting this option, you will not be able to revert back to using legacy property naming. If you are not facing issues with your template property names, we recommend leaving this unchecked."







), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx("b", {}, void 0, /*#__PURE__*/
_jsx(Translate, { translationKey: "Character support process warning" }, void 0, "This process could take several minutes and will likely change URLs to library filters. If you have menus or links using such URLs, they will probably stop working after the update. You will need to update them manually."



)
), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx(Translate, { translationKey: "Character support revert warning" }, void 0, "After selecting this option, you will not be able to revert back to using legacy property naming. If you are not facing issues with your template property names, we recommend leaving this unchecked."



)
);


export const analytics = /*#__PURE__*/
_jsx(Translate, { translationKey: "Analytics description" }, void 0, "If you want to track analytics related to your collection visits, Uwazi supports both Google Analytics and Matomo."


);


export const mapAxis = /*#__PURE__*/
_jsx(Translate, {}, void 0, "Set the default starting point for your geolocation properties.");


export const publicForm = [/*#__PURE__*/
_jsx(Translate, { translationKey: "Public form settings description" }, void 0, "Here you can configure the public form destination and the whitelisted templates"

), /*#__PURE__*/
_jsx(Translate, { translationKey: "Public form URL description" }, void 0, "If you have configured a public form and would like a different Uwazi collection to receive the submissions, enter its URL here."


), /*#__PURE__*/
_jsx(Translate, { translationKey: "Public form whitelist description" }, void 0, "If you wish to include Public Forms on your pages, you must white-list the template IDs for which Public Forms are expected."


)];


export const mapLayers = /*#__PURE__*/
_jsx(Translate, { translationKey: "Map layers description" }, void 0, "Here you can configure the map layers that will be available in the maps."

);


export const openPublicForm = /*#__PURE__*/
_jsx(Translate, { translationKey: "Captcha bypass" }, void 0, "By toggling this on you can allow users to submit to your whitelisted templates without having to fill a CAPTCHA. The form will still present the captcha to end users, but API end-point will allow submissions without CAPTCHA validation if a header `\u201CBypass-Captcha: true`\u201C is sent along. This option is insecure and can be leveraged to flood your instance with spam or malicious content."





);


export const mapApiKey = /*#__PURE__*/
_jsx(Translate, { translationKey: "Map api key tooltip" }, void 0, "An API key is required to use Mapbox or Google Maps."

);


export const ocrTrigger = /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, { translationKey: "OCR description tip 1" }, void 0, "This will enable the Optical Character Recognition (OCR) functionality for PDF documents. This service will recognize text inside images, such as scanned documents and photos, and convert it into machine-readable text data."



), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx(Translate, { translationKey: "OCR description tip 2" }, void 0, "When activated, this will enable administrator and editor users to send PDF documents to the OCR service."


)
);


export const globalJS = /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, {}, void 0, "With great power comes great responsibility!"), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx(Translate, {}, void 0, "This area allows you to append custom Javascript to the page. This opens up a new universe of possibilities."


), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx(Translate, {}, void 0, "It could also very easily break the app. Only write code here if you know exactly what you are doing."


)
);